// 2020-06-27export { TropaCategoriaGanadoComponent } from './tropa-categoria-ganado.component';